import React, {useEffect, useState} from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField, FormControlLabel, Switch, Container
} from '@mui/material';
import Cookies from "js-cookie";
import axios from "axios";
import _ from 'lodash';
import ConfirmationDialog from "./ConfirmationDialog";

const ManageQueuePanel= ({ queueData }) => {
    const [queue, setQueue] = useState(null);
    const [originalQueue, setOriginalQueue] = useState(null);
    const [isChanged, setIsChanged] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [pendingToggle, setPendingToggle] = useState(null);

    useEffect(() => {
        if(queueData) {
            setQueue({
                ...queueData,
                startTime: formatDateTime(queueData.startTime),
                endTime: formatDateTime(queueData.endTime)
            });
            setOriginalQueue({
                ...queueData,
                startTime: formatDateTime(queueData.startTime),
                endTime: formatDateTime(queueData.endTime)
            });
        } else {
            setQueue({});
        }
    }, [])


    useEffect(() => {
        if(queueData) {
            setOriginalQueue({
                ...queueData,
                startTime: formatDateTime(queueData.startTime),
                endTime: formatDateTime(queueData.endTime)
            });
        }
    }, [queueData])

    //checks if queue data has been changed and enables save button
    useEffect(() => {
        if(_.isEqual(queue, originalQueue)){
            setIsChanged(false);
        } else {
            setIsChanged(true);
        }
    }, [queue]);

    const handleChange = (event) => {
        setQueue({ ...queue, [event.target.name]: event.target.value });
    };

    const handleToggleChange = (event) => {
        // If toggling isActive, show confirmation dialog
        if (event.target.name === 'isActive') {
            setPendingToggle(event.target.checked);
            setShowConfirmation(true);
        } else {
            setQueue({ ...queue, [event.target.name]: event.target.checked });
        }
    };

    const handleConfirmToggle = () => {
        setQueue({ ...queue, isActive: pendingToggle });
        setShowConfirmation(false);
        setPendingToggle(null);
    };

    const handleCancelToggle = () => {
        setShowConfirmation(false);
        setPendingToggle(null);
    };

    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return '';
        return dateTimeString.split('.')[0];
    };

    const onSave = async () => {
        const csrfToken = Cookies.get('XSRF-TOKEN');
        const headers = { 'X-CSRF-TOKEN': csrfToken };

        try {
            if (queue) {
                // Update existing queue
                const newQueue = await axios.put(`/api/queues/staff/${queue.queueId}`, queue, { headers });
                setIsChanged(false);
                setOriginalQueue({
                    ...newQueue,
                    startTime: formatDateTime(newQueue.startTime),
                    endTime: formatDateTime(newQueue.endTime)
                });
            }
        } catch (error) {
            console.error('Error saving queue', error);
            // Handle errors (e.g., show an error message)
        }
    };


    return (
        <>
            <ConfirmationDialog
                open={showConfirmation}
                onClose={handleCancelToggle}
                onConfirm={handleConfirmToggle}
                title="Warning: Toggling Active Status"
                message="Toggling the Active status will DELETE ALL GROUPS from all queues. This action cannot be undone. Are you sure you want to continue?"
                confirmText="Yes, Continue"
                cancelText="Cancel"
            />
            <Container>
            <Container>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            label="Capacity"
                            type="number"
                            fullWidth
                            name="capacity"
                            value={queue?.capacity}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            label="No-Show Setback"
                            type="number"
                            fullWidth
                            name="noShowSetBack"
                            value={queue?.noShowSetBack}
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            label="Start Time"
                            type="datetime-local"
                            fullWidth
                            name="startTime"
                            value={queue?.startTime || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            label="End Time"
                            type="datetime-local"
                            fullWidth
                            name="endTime"
                            value={queue?.endTime || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControlLabel sx={{padding: 2}}
                                          control={
                                              <Switch
                                                  checked={queue?.isActive || false}
                                                  onChange={handleToggleChange}
                                                  name="isActive"
                                              />
                                          }
                                          label="Is Active"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel sx={{padding: 2}}
                                          control={
                                              <Switch
                                                  checked={queue?.isCancelled || false}
                                                  onChange={handleToggleChange}
                                                  name="isCancelled"
                                              />
                                          }
                                          label="Is Cancelled"
                        />
                    </Grid>
                </Grid>
            </Container>
            <Container sx={{display: 'flex', justifyContent: 'space-around ', marginBottom: 2}}>
                <Button onClick={onSave} variant="contained" disabled={!isChanged}>Save</Button>
            </Container>
        </Container>
        </>
    );
};

export default ManageQueuePanel;
